export default [
  {
    path: '/monitoring-pickup',
    name: 'monitoring-pickup',
    component: () => import('@/views/pages/komship/monitoring-pickup/List.vue'),
    meta: {
      resource: 'Komship - Order & Pickup',
      navActiveLink: 'monitoring-pickup',
      action: 'read',
    },
  },
]
